// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"334":"app-theme-dark1","522":"app-theme-dark0","554":"app-theme-light1","641":"app-theme-light0"}[chunkId] || chunkId) + "." + {"198":"88a88ba2","334":"110562b0","498":"5f4fb753","522":"b9ebf096","554":"4559c3bb","641":"9a2efd19","703":"4418231e"}[chunkId] + ".chunk.js";
};